import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { FrameInterface, setEditId, setEditError, selectFrameById } from "../../../store/mine_craft/framesSlice";
import { updateFrame, fetchFrame } from "../../../actions/mine_craft/framesActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.frames.editId);
  const error = useAppSelector(state => state.mineCraft.frames.editError);
  const frame = useAppSelector(state => id ? selectFrameById(state, id) : undefined);
  const params: any = { ...frame };

  useEffect(() => {
    if (id) {
      dispatch(fetchFrame(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: FrameInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateFrame({ id, data: formData }));

    if (updateFrame.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-frame'>
        <h6 className="v-content-label">Edit Frame</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
